const ICON_DIR = 'content-block-icons';

export function getContentBlockPaletteIconSrc(blockType: string): string {
  const base = process.env.PUBLIC_URL ?? '';
  const prefix = base.endsWith('/') ? base.slice(0, -1) : base;
  const path = `/${ICON_DIR}/${encodeURIComponent(blockType)}.svg`;
  return prefix ? `${prefix}${path}` : path;
}
